import { navigate } from "vike/client/router"
import React from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import Image from "aldoo-ra/Image"
import Text from "aldoo-ra/Text"
import MenuGroup from "aldoo-ra/MenuGroup"

function NotFoundPage() {
  return (
    <div className="relative min-h-screen bg-gradient-to-br from-canvas via-neutral to-paper transition-colors">
      <div className="relative flex flex-col w-full min-h-screen items-center justify-center gap-[50px] px-4">
        {/* 404 image */}
        <div className="w-[580px] h-[326px]">
          <Image 
            id="page_not_found"
            alt="page not found"
            className="max-w-full h-auto" 
          />
        </div>
        
        <Text 
          id="not_found_page"
          component="h1"
          variant="body1_accent" 
          className="text-center my-0"
        />
        {/* We couldn't find the page you're looking for */}
        
        <MenuGroup
          name="BackToHome"
          renderAs="hlist"
          itemsAsLinks={false}
          styleOverrides={{
            menu: "flex flex-row items-center py-0 my-0",
            menu_item: "list-none px-0 py-0 my-0",
          }}
          menuItemRender={(item) => (
            <Button
              variant="primary_m"
              onClick={() => navigate(item.link?.[0]?.url)}
            >
              {item.label}
            </Button>
          )}
        />
      </div>
    </div>
  )
}

export default NotFoundPage